// src/api.js
import axios from 'axios';

// Create an axios instance with environment-aware base URL.
// - Development defaults to local backend on port 3000.
// - Production uses same-origin /api and relies on server-side proxy.
const api = axios.create({
  baseURL:
    process.env.REACT_APP_API_URL ||
    (process.env.NODE_ENV === 'development' ? 'http://localhost:3000/api' : '/api'),
});

// Request interceptor: automatically add the token to every request
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('dashboardToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Optional: Response interceptor to handle common errors (e.g., 401)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid – logout user
      localStorage.removeItem('dashboardToken');
      window.location.href = '/';
    }
    return Promise.reject(error);
  }
);

export default api;